import { render, staticRenderFns } from "./Pastavshik.vue?vue&type=template&id=8bd90680&scoped=true"
import script from "./Pastavshik.vue?vue&type=script&lang=js"
export * from "./Pastavshik.vue?vue&type=script&lang=js"
import style0 from "./Pastavshik.vue?vue&type=style&index=0&id=8bd90680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd90680",
  null
  
)

export default component.exports